export const SET_REFRESH = 'SET_REFRESH'
export const DASHBOARD_REFRESH = 'DASHBOARD_REFRESH'